import React, { useEffect } from "react";
import { Form, Row, Col, Divider, Checkbox, Typography, Select, Input } from "antd";
import { c_RegimenFiscal, c_UsoCFDI } from "../../../SATCatalogos/index";

const { Title } = Typography;
const { Option } = Select;

const ReceptorSection = (props) => {
    const { cliente } = props;

    const formRef = Form.useFormInstance();

    useEffect(() => {

        if (cliente) {
            formRef.setFieldsValue({
                Receptor: {
                    Nombre: cliente.razon_social,
                    Rfc: cliente.rfc,
                    DomicilioFiscalReceptor: cliente.codigo_postal,
                    UsoCFDI: cliente.uso_cfdi,
                    RegimenFiscalReceptor: cliente.regimen_fiscal,
                },
            });
        }
    }, [cliente]);

    return (
        <>
            <Row>
                <Divider orientation="left" style={{ margin: "12px 0 24px 0 " }} />
                <Title level={5} className="mb-1">
                    Información del Receptor
                </Title>
            </Row>
            <Row className="mb-1">
                <Col span={24}>
                    <Form.Item noStyle name="enviar_receptor" valuePropName="checked">
                        <Checkbox>Enviar al Receptor una copia de la factura</Checkbox>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={[16, 16]}>
                <Col xs={20} md={24}>
                    <Form.Item
                        name={["Receptor", "Nombre"]}
                        label="Nombre / Razón Social del Emisor"
                        rules={[
                            {
                                required: true,
                                message: "Ingrese el Nombre / Razón Social del Receptor",
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col xs={20} md={12}>
                    <Form.Item
                        name={["Receptor", "Rfc"]}
                        label="Registro Federal de Contribuyentes (RFC)"
                        rules={[
                            {
                                required: true,
                                message: "Ingrese el RFC del cliente / receptor.",
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col xs={20} md={12}>
                    <Form.Item
                        name={["Receptor", "DomicilioFiscalReceptor"]}
                        label="Domicilio Fiscal Receptor (Código Postal)"
                        rules={[{ required: true, message: "Ingrese el domicilio del cliente." }]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col xs={20} md={12}>
                    <Form.Item
                        name={["Receptor", "UsoCFDI"]}
                        label="Uso del CFDI"
                        rules={[{ required: true, message: "Seleccione una opción." }]}
                    >
                        <Select showSearch optionFilterProp="filter">
                            {c_UsoCFDI.map(({ uso_cfdi, descripción }) => (
                                <Option
                                    key={uso_cfdi}
                                    filter={`${uso_cfdi} ${descripción}`}
                                    value={uso_cfdi}
                                >
                                    <strong>{uso_cfdi}</strong> - {descripción}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
                <Col xs={20} md={12}>
                    <Form.Item
                        name={["Receptor", "RegimenFiscalReceptor"]}
                        label="Régimen Físcal Receptor"
                        rules={[{ required: true, message: "Seleccione un régimen fiscal" }]}
                    >
                        <Select showSearch optionFilterProp="filter">
                            {c_RegimenFiscal.map(({ regimen_fiscal, descripción }) => (
                                <Option
                                    key={regimen_fiscal}
                                    filter={`${regimen_fiscal} ${descripción}`}
                                    value={regimen_fiscal}
                                >
                                    <strong>{regimen_fiscal}</strong> - {descripción}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
            </Row>
        </>
    );
};

export default ReceptorSection;
